import { FetchProducersQuery, Producer } from 'types/producer'
import getProducers from './getProducers'

/**
 * Get all showcase producers
 *
 * @param {FetchProducersQuery} filters
 * @returns {Promise<Producer[]>}
 */
const getFeaturedProducers = async ({ language }: FetchProducersQuery): Promise<Producer[]> => {
  try {
    // Set the params to get the featured producers
    const params = { enabled: true, soldOut: false }

    // Fetch the producers
    const producers = await getProducers({ language, params })

    // Filter the producers that are featured
    let featuredProducers = producers
      .filter((prod: Producer) => prod.isFeatured[language])
      .sort((p1: Producer, p2: Producer) => (p1.order < p2.order ? -1 : p1.order > p2.order ? 1 : 0))
      .slice(0, 3)

    // If there are no featured producers, get the first 4 producers
    if (!featuredProducers?.length) {
      featuredProducers = producers.slice(0, 3)
    }

    return featuredProducers
  } catch (_) {
    return []
  }
}

export default getFeaturedProducers
